import Enumerator from '../global/Enumerator';

export const incomeTypes = [
  'payg_income',
  'business_income',
  'other_taxable_income',
  'non_taxable_income'
];

export class IncomeType extends Enumerator {
  static default() {
    return this.of('payg_income');
  }
}

IncomeType.initEnum({
  payg_income: {
    get id() {
      return 'payg_income';
    },
    get title() {
      return 'Salaried employee';
    },
    get weight() {
      return 1;
    }
  },
  business_income: {
    get id() {
      return 'business_income';
    },
    get title() {
      return 'Business income';
    },
    get weight() {
      return 2;
    }
  },
  other_taxable_income: {
    get id() {
      return 'other_taxable_income';
    },
    get title() {
      return 'Other taxable income';
    },
    get weight() {
      return 3;
    }
  },
  non_taxable_income: {
    get id() {
      return 'non_taxable_income';
    },
    get title() {
      return 'Non taxable income';
    },
    get weight() {
      return 4;
    }
  }
});

export default {
  incomeTypes,
  IncomeType
};
